"use strict";
import { Action } from "../actions";
import { Record } from "immutable";
const defaultAdjustments = Record({
  sharpen: 0,
  contrast: 0,
  brightness: 0,
  despeckle: 0
});
export default function toneAdjustmentReducer(toneAdjustments = defaultAdjustments(), action) {
  let adjustments = toneAdjustments;
  switch (action.type) {
    case Action.ADJUST_TONE: {
      switch (action.adjustment) {
        case "sharpen": {
          adjustments = adjustments.set("sharpen", action.value);
          break;
        }
        case "contrast": {
          adjustments = adjustments.set("contrast", action.value);
          break;
        }
        case "brightness": {
          adjustments = adjustments.set("brightness", action.value);
          break;
        }
        case "despeckle": {
          adjustments = adjustments.set("despeckle", action.value);
          break;
        }
      }
      break;
    }
    case Action.LOADING_ANNOTATIONS_SUCCEEDED: {
      adjustments = defaultAdjustments(action.toneAdjustments || {});
      break;
    }
    default:
      break;
  }
  return adjustments;
}
